import { ApolloClient } from '@apollo/client';
import { InMemoryCache } from '@apollo/client';
import config from '../../temp/config';
import { sha256 } from 'crypto-hash';

/*
  INTROSPECTION DATA
  See https://www.apollographql.com/docs/react/recipes/fragment-matching.html
  This enables the Apollo cache to process fragments on interface types correctly.
  If this file does not exist, you may need to run the `jss graphql:update` script.
*/
import introspectionQueryResultData from '../../temp/GraphQLFragmentTypes.json';

// choose between a basic HTTP link to run queries...
// import { createHttpLink } from 'apollo-link-http';
// const link = createHttpLink({ uri: endpoint, credentials: 'include' });

// ...or a batched link (multiple queries within 10ms all go in one HTTP request)
import { BatchHttpLink } from '@apollo/client/link/batch-http';

// ...and an automatic persisted query link, which reduces bandwidth by using query hashes to alias content
// the APQ link is _chained_ behind another link that performs the actual HTTP calls, so you can choose
// APQ + batched, or APQ + http links for example.
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';

const client = new ApolloClient({
  link: createPersistedQueryLink({ sha256 }).concat(
    new BatchHttpLink({
      uri: config.graphQLEndpoint,
      credentials: 'include',
    })
  ),
  cache: new InMemoryCache(),
  ssrMode: false,
  ssrForceFetchDelay: 10,
});

export default client;
